import { route } from '@/ziggy-shim';
import { api, CastValue } from './LaravelClient';

export default {
  async create(projectId: Id, packageId: Id, data: ApiRequests['api.v1.package-trade-items.store']) {
    return await api(route('api.v1.package-trade-items.store', [projectId, packageId]), 'post', {
      data,
      casts: {
        quantity: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        rate: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        wbs_code_id: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async update(id: Id, data: ApiRequests['api.v1.package-trade-items.update']) {
    return await api(route('api.v1.package-trade-items.update', id), 'patch', {
      data,
      casts: {
        wbs_code_id: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async updateForecastAmounts(id: Id, data: ApiRequests['api.v1.package-trade-items.forecast-amounts']) {
    return await api(route('api.v1.package-trade-items.forecast-amounts', id), 'patch', {
      data,
    });
  },

  async delete(id: Id) {
    return await api(route('api.v1.package-trade-items.destroy', id), 'delete');
  },

  async assignWbsCode(packageId: Id, data: ApiRequests['api.v1.package-trade-items.wbs-code']) {
    return await api(route('api.v1.package-trade-items.wbs-code', packageId), 'post', {
      data,
    });
  },
};
